import defaultAxiosClient from '../../plugins/axios';
import {extractFileNameAndSave} from "@/util/FormattingUtil";
import {shiftDtoEndDatePlusOneDayIfPastMidnight, toYearAndMonth} from "@/util/DateUtil";
import WorkShift from "@/domain/WorkShift";
import {sortListByColumnAndDirection} from '@/util/SortingUtil';
import Vue from "vue";
import {toAbsenceObject} from "@/constants/Absences";
import {toYear} from "../../util/DateUtil";

const initialState = {
    timeSheetDays: [],
    contractWithTimeSheetInfo: [],
    selectedTimeSheetInfo: {
        hourlyRates: []
    },
    fullTimeSheet: {
        invoiceDtos: []
    },
    completed: false,
    completedMappingObject: {},
    isShowingLockedVersion: false,
    nextMonthAvailable: false,
    previousMonthAvailable: false,
    hasPreviousContract: false,
    hasNextContract: false,
    currentlySelectedContractId: 0,
    currentlySelectedContractIndex: 0,
    currentlySelectedUserId: 0,
    workShifts: [],
    workedShifts: [],
    freeCosts: [],
	customerId: "",
    availableShiftTypes: [],
    activeContracts: [],
    isInvoiced: false,
    isLocked: false,
	viewHourlyRateInfo: [],
	availableVacationCountersForUser: [],
	workedHoursThisYear: []
};

const timesheet = {
	namespaced: true,
	state() {
		return {...initialState};
	},
	getters: {
		timeSheetDays: state => state.timeSheetDays,
		contractWithTimeSheetInfo: state => state.contractWithTimeSheetInfo,
		selectedTimeSheetInfo: state => state.selectedTimeSheetInfo,
		fullTimeSheet: state => state.fullTimeSheet,
		completed: state => state.completed,
		completedMappingObject: state => state.completedMappingObject,
		isShowingLockedVersion: state => state.isShowingLockedVersion,
		nextMonthAvailable: state => state.nextMonthAvailable,
		previousMonthAvailable: state => state.previousMonthAvailable,
		currentlySelectedContractId: state => state.currentlySelectedContractId,
		currentlySelectedContractIndex: state => state.currentlySelectedContractIndex,
		currentlySelectedUserId: state => state.currentlySelectedUserId,
		workShifts: state => state.workShifts,
		workedShifts: state => state.workedShifts,
		freeCosts: state => state.freeCosts,
		absenceDays: state => state.absenceDays,
		availableShiftTypes: state => state.availableShiftTypes,
		hasPreviousContract: state => state.hasPreviousContract,
		hasNextContract: state => state.hasNextContract,
		activeContracts: state => state.activeContracts,
		customerId: state => state.customerId,
		previousContractWithTimeSheetInfo: (state) => {
			let sortedContracts = sortListByColumnAndDirection(state.contractWithTimeSheetInfo, "username", true);
			let indexOfCurrentContract = sortedContracts.map(contract => contract.contractId).indexOf(state.currentlySelectedContractId);
			return sortedContracts[indexOfCurrentContract - 1];
		},
		nextContractWithTimeSheetInfo: (state) => {
			let sortedContracts = sortListByColumnAndDirection(state.contractWithTimeSheetInfo, "username", true);
			let indexOfCurrentContract = sortedContracts.map(contract => contract.contractId).indexOf(state.currentlySelectedContractId);
			return sortedContracts[indexOfCurrentContract + 1];
		},
		isLocked: state => state.isLocked,
		viewHourlyRateInfo: state => state.viewHourlyRateInfo,
		availableVacationCountersForUser: state => state.availableVacationCountersForUser,
		workedHoursThisYear:  state => state.workedHoursThisYear
	},
	mutations: {
		resetState(state) {
			Object.assign(state, initialState);
		},
		setTimeSheetDays: (state, timeSheetDays) => {
			state.timeSheetDays = timeSheetDays;
		},
		setTimeSheetDay: (state, index, timeSheetDay) => {
			state.timeSheetDays[index] = timeSheetDay;
		},
		setContractWithTimeSheetInfo(state, payload) {
			state.contractWithTimeSheetInfo = payload;
		},
		updateContractWithTimeSheetInfo(state, updatedContracts) {
			const dataToObjects = [];
			state.contractWithTimeSheetInfo.forEach(contract => {
				const optUpdateContract = updatedContracts.filter(updatedContract => contract.contractId === updatedContract.contractId);
				if (optUpdateContract.length) {
					dataToObjects.push(optUpdateContract[0]);
				} else {
					dataToObjects.push(contract);
				}
			});
			state.contractWithTimeSheetInfo = dataToObjects;
		},
		unLock(state) {
			state.contractWithTimeSheetInfo.locked = false;
		},
		setSelectedCustomerTimesheetInfo(state, payload) {
			state.selectedTimeSheetInfo = payload;
		},
		setFullTimeSheet(state, payload) {
			state.fullTimeSheet = payload;
		},
		setIsShowingLockedVersion(state, payload) {
			state.isShowingLockedVersion = payload;
		},
		setPreviousMonthAvailable(state, previousMonthAvailable) {
			state.previousMonthAvailable = previousMonthAvailable;
		},
		setFreeCosts(state,freeCosts){
			state.freeCosts = freeCosts;
		},
		setCustomerId(state,customerId){
			state.customerId =customerId;
		},
		setNextMonthAvailable(state, nextMonthAvailable) {
			state.nextMonthAvailable = nextMonthAvailable;
		},
		setHasPreviousContract(state, hasPreviousContract) {
			state.hasPreviousContract = hasPreviousContract;
		},
		setHasNextContract(state, hasNextContract) {
			state.hasNextContract = hasNextContract;
		},
		setCurrentlySelectedContractId(state, currentlySelectedContractId) {
			state.currentlySelectedContractId = currentlySelectedContractId;
		},
		setCurrentlySelectedContractIndex(state, currentlySelectedContractIndex) {
			state.currentlySelectedContractIndex = currentlySelectedContractIndex;
		},
		setCurrentlySelectedUserId(state, currentlySelectedUserId) {
			state.currentlySelectedUserId = currentlySelectedUserId;
		},
		setAllWorkShifts(state, workShifts) {
			const dataToObjects = [];
			let shiftObj;
			workShifts.forEach((customerShift) => {
				customerShift.workedShiftDTOList.forEach((workShift) => {
					shiftObj = new WorkShift(
						workShift.shiftTypeId,
						workShift.labourPeriod,
						workShift.breakPeriod,
						workShift.color,
						workShift.name,
						customerShift.customerName,
						customerShift.contractId,
						workShift.remark,
						workShift.workedHours,
						workShift.interrupted,
						workShift.callout,
						workShift.editedByAdmin);
					dataToObjects.push(shiftObj);
				});
			});
			state.workShifts = dataToObjects;
		},
		setAllWorkedShifts(state, payload) {
			const dataToObjects = [];
			let shiftObj;
			payload.workedShifts.forEach((workedShift) => {
				shiftObj = new WorkShift(
					workedShift.shiftTypeId,
					workedShift.labourPeriod,
					workedShift.breakPeriod,
					workedShift.color,
					workedShift.name,
					payload.customerName,
					payload.contractId,
					workedShift.remark,
					workedShift.workedHours,
					workedShift.interrupted,
					workedShift.callout,
					workedShift.editedByAdmin);
				dataToObjects.push(shiftObj);
			});
			state.workedShifts = dataToObjects;
		},
		setAbsences(state, absenceDtos) {
			let absences = [];

            absenceDtos.forEach(absenceDto => {
                const absence = toAbsenceObject(absenceDto);
                if (absence) {
                    absences.push({
                        start: absenceDto.date,
                        allDay: absence.allDay,
                        color: absence.color,
                        textColor: absence.textColor,
                        absenceCategory: absenceDto.absenceType.absenceCategory,
                        fullDay: absenceDto.absenceType.fullDay,
                        title: absenceDto.absenceType.userReadableFormat,
                        hours: absenceDto.hours,
                        editedByAdmin: absenceDto.editedByAdmin
                    });
                }
            });
            state.absenceDays = absences;
        },
        setAvailableShiftTypes(state, customer) {
            state.availableShiftTypes = customer.shiftTypes;
        },
        setActiveContracts(state, contracts) {
            state.activeContracts = contracts;
        },
        setCompleted(state, boolean) {
            state.completed = boolean;
        },
        setLocked(state, boolean) {
            state.isLocked = boolean;
        },
		setAvailableVacationCountersForUser(state, availableVacationCountersForUser) {
			state.availableVacationCountersForUser = availableVacationCountersForUser;
		},
        addToCompletedMappingObject(state, payload) {
            const contractId = payload.contractId;
            const completed = payload.completed;

			Vue.set(state.completedMappingObject, contractId, completed);
		},
		setViewHourlyRateInfo(state, payload) {
			state.viewHourlyRateInfo = payload;
		},
		setWorkedMonthlyHoursByYear(state, payload){
			state.workedHoursThisYear = payload;
		}
	},
	actions: {
		updateAbsenceCountersBySDWorxCode({commit}, payload){
			return defaultAxiosClient.post('/administration/timesheet/updateAbsenceCounters/'+ payload.year, payload.updateCounterDto)
				.then(response => {
					if (response.data._embedded !== undefined) {
						commit('setTimeSheetDay', response.data._embedded.adminReducedDayInTimeSheetDto);
					}
				});
		},
		fetchContractWithTimeSheetInfo({commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			return defaultAxiosClient.get(`/administration/contract/${yearMonth}/all`)
				.then(response => commit('setContractWithTimeSheetInfo', response.data._embedded?.contractWithTimeSheetInfoDtoList))
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchFreeCosts({state}) {
			const yearMonth = toYearAndMonth(state.yearMonth);
			const contractId = state.selectedTimeSheetInfo.contractId;
			const userid = state.currentlySelectedUserId;
			defaultAxiosClient.get("/administration/invoice/" + yearMonth + "/" + contractId + '/'+userid+"/freeCost")
				.then(response => {
					state.freeCosts = [];
					state.freeCosts = [...response.data._embedded.freeCostDTOList];
				});
		},
		reopenTimeSheet({commit}, contractId) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			defaultAxiosClient.put(`/administration/contract/${yearMonth}/reopen/${contractId}`)
				.then(response => commit('updateContractWithTimeSheetInfo', response.data._embedded?.contractWithTimeSheetInfoDtoList));
		},
		unlockTimeSheet({commit}, contractId) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			defaultAxiosClient.put(`/administration/contract/${yearMonth}/unlock/${contractId}`)
				.then((response) => {
					commit('updateContractWithTimeSheetInfo', response.data._embedded?.contractWithTimeSheetInfoDtoList);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		toggleConfirmedForInvoice({commit}, contractId){
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			return defaultAxiosClient.put(`/administration/contract/${yearMonth}/toggleConfirmForInvoice/${contractId}`)
				.then((response) => {
					commit('updateContractWithTimeSheetInfo', response.data._embedded?.contractWithTimeSheetInfoDtoList);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		lockAllPlannings({commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			defaultAxiosClient.put('/administration/contract/' + yearMonth + '/lockall')
				.then((response) => {
					commit('updateContractWithTimeSheetInfo', response.data._embedded?.contractWithTimeSheetInfoDtoList);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchTimeSheetDays({commit, state}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const userId = state.selectedTimeSheetInfo.userId;
			return defaultAxiosClient.get(`/administration/timesheet/${userId}/${yearMonth}`)
				.then((response) => commit('setTimeSheetDays', response.data.adminReducedDayInTimeSheetDtoList))
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		createUser(rootState, createUserDto) {
			return defaultAxiosClient.post("/administration/user", createUserDto);
		},
		createCustomer(rootState, createCustomerDto) {
			return defaultAxiosClient.post("/administration/customer", createCustomerDto);
		},
		createContract(rootState, createContractDto) {
			return defaultAxiosClient.post("/administration/contract", createContractDto);
		},
		fetchFullTimeSheet({state, commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.currentlySelectedContractId;
			defaultAxiosClient.get("/administration/timesheet/" + contractId + "/" + yearMonth + "/worked")
				.then(response => {
					commit("setFullTimeSheet", response.data);
					commit("setAllWorkedShifts",
						{
							workedShifts: response.data.workedShiftDtos,
							customerName: null,
							contractId: response.data.contractId
						});
					commit("setNextMonthAvailable",response.data.nextMonthAvailable);
					commit("setPreviousMonthAvailable",response.data.previousMonthAvailable);
					commit("setFreeCosts",response.data.freeCosts);
					commit("setCustomerId",response.data._links.customer.href.split("/")[6]);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});

		},
		fetchWorkedCustomerTimesheetWithContractInfo({state, commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.selectedTimeSheetInfo.contractId;
			this.currentlySelectedContractId = contractId;
			return defaultAxiosClient.get(`/administration/timesheet/${contractId}/${yearMonth}/all`)
				.then(response => {
					processAbsenceSheetAfterFullGet(commit, response);
					commit('setCurrentlySelectedUserId', response.data.userId);
					commit('setAllWorkedShifts',
						{
							workedShifts: response.data.customerTimesheetWorkedDto.workedShiftDtos,
							customerName: response.data.customerName,
							contractId: response.data.customerTimesheetWorkedDto.contractId
						});
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		updateContractAvailability({state,commit}){
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.selectedTimeSheetInfo.contractId;
			this.currentlySelectedContractId = contractId;
			return defaultAxiosClient.get(`/contract/${contractId}/${yearMonth}/availability`)
				.then(response => {
					commit("setNextMonthAvailable",response.data.nextMonthAvailable);
					commit("setPreviousMonthAvailable",response.data.previousMonthAvailable);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchContractsForSelectedUser({state, commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const userId = state.selectedTimeSheetInfo.userId;
			return defaultAxiosClient.get(`/administration/contract/${yearMonth}/all/${userId}`)
				.then(response => {
					const contractWithShiftTypesAndOrdersOutputDtoList = response.data._embedded?.contractWithShiftTypesAndOrdersOutputDtoList;
					commit('timesheet/setActiveContracts', contractWithShiftTypesAndOrdersOutputDtoList, {root: true});
					commit('timesheet/setSelectedContract',
						contractWithShiftTypesAndOrdersOutputDtoList.length >= 1 ?
							contractWithShiftTypesAndOrdersOutputDtoList[0] :
							undefined,
						{root: true}
					);
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchPlannedDataForSelectedTimeSheet({state, commit}) {
			const userId = state.selectedTimeSheetInfo.userId;
			const contractId = state.selectedTimeSheetInfo.contractId;
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get(`/administration/timesheet/${contractId}/${yearMonth}/planned/${userId}`)
				.then(response => processTimeSheet(commit, response, contractId))
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchLockedDataForSelectedTimeSheet({state, commit}) {
			const userId = state.selectedTimeSheetInfo.userId;
			const contractId = state.selectedTimeSheetInfo.contractId;
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get(`/administration/timesheet/${contractId}/${yearMonth}/locked/${userId}`)
				.then(response => processTimeSheet(commit, response, contractId))
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchAbsenceDataForSelectedTimeSheet({state, commit}) {
			const userId = state.selectedTimeSheetInfo.userId;
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get(`/administration/timesheet/${yearMonth}/absences/${userId}`)
				.then(response => {
					processAbsenceSheet(commit, response);
					commit('timesheet/setRemainingVacationDays', response.data.remainingVacationDays, {root: true});
				})
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		fetchLockedAbsenceDataForSelectedTimeSheet({state, commit}) {
			const userId = state.selectedTimeSheetInfo.userId;
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get(`/administration/timesheet/${yearMonth}/absences/locked/${userId}`)
				.then(response => processAbsenceSheet(commit, response))
				.catch(() => {
					commit('timesheet/resetState', null, {root: true});
					commit('resetState');
				});
		},
		addFreeCost({state}, {yearMonth, contractId, createFreeCostDto}) {
			const userId = state.currentlySelectedUserId;
			return defaultAxiosClient.post('/administration/timesheet/' + yearMonth + '/' + userId + '/' + contractId + '/freeCost', createFreeCostDto)
				.then(response => {
					state.freeCosts = [];
					state.freeCosts = [...response.data._embedded.freeCostDTOList];
				});
		},
		removeFreeCost({state}, removeFreeCostDto) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.selectedTimeSheetInfo.contractId;
			const userId = state.currentlySelectedUserId;
			return defaultAxiosClient.post('/administration/timesheet/' + yearMonth + '/' + userId + '/'+contractId+'/deleteFreeCost', removeFreeCostDto)
				.then(response => {
					state.freeCosts = [];
					state.freeCosts = [...response.data._embedded.freeCostDTOList];
				});
		},
		updateFreeCost({state}, freeCostToUpdate) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.selectedTimeSheetInfo.contractId;
			const userId = state.currentlySelectedUserId;
			return defaultAxiosClient.post('/administration/timesheet/' + yearMonth + '/' + userId + '/'+ contractId + '/updateFreeCost', freeCostToUpdate)
				.then(response => {
					state.freeCosts = [];
					state.freeCosts = [...response.data._embedded.freeCostDTOList];
				});
		},

		downloadAdminTimeSheet({commit}, contractId) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			let uri = `/administration/timesheet/${contractId}/${yearMonth}/download`;

            return defaultAxiosClient.get(uri, {
                responseType: "arraybuffer",
                headers: {
                    'Accept': 'application/pdf'
                }
            }).then((response) => {
                const blob = new Blob([response.data], {type: 'application/pdf'});
                extractFileNameAndSave(response, blob);
            })
				.catch(() => {
					commit('resetState');
				});
        },
		downloadCsv({state}) {
			const userId = state.selectedTimeSheetInfo.userId;
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

            return defaultAxiosClient.get(`/administration/timesheet/${userId}/${yearMonth}/csv`, {
                responseType: "arraybuffer",
                headers: {
                    'Accept': 'application/csv',
                }
            }).then((response) => {
                const blob = new Blob([response.data], {type: 'application/csv'});
                extractFileNameAndSave(response, blob);
            });
        },
        downloadEBlox({state}) {
            const userId = state.selectedTimeSheetInfo.userId;
            const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			return defaultAxiosClient.get(`/administration/timesheet/${userId}/${yearMonth}/eblox`, {
				responseType: "arraybuffer",
				headers: {
					'Accept': 'application/csv',
				}
			}).then((response) => {
				const blob = new Blob([response.data], {type: 'application/csv'});
				extractFileNameAndSave(response, blob);
			});
		},
		downloadEBloxForHREmployer({commit}, hrEmployerId) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			return defaultAxiosClient.get(`/administration/timesheet/${hrEmployerId}/${yearMonth}/hremployer/eblox`, {
				responseType: "arraybuffer",
				headers: {
					'Accept': 'application/csv',
				}
			}).then((response) => {
				const blob = new Blob([response.data], {type: 'application/csv'});
				extractFileNameAndSave(response, blob);
			})
				.catch(commit('resetState'));
		},
		addWorkedShift({commit}, {contractId, yearMonth, createWorkedShiftDto}) {
			return defaultAxiosClient.put('/administration/timesheet/' + contractId + '/' + yearMonth + '/worked/createshift', createWorkedShiftDto)
				.then(response =>
					commit('setAllWorkedShifts',
						{
							workedShifts: response.data.workedShiftDTOList,
							customerName: response.data.customerName,
							contractId: response.data.contractId
						})
				);
		},
		addAbsence({commit, state, rootState}, {yearMonth, userId, createAbsenceDto}) {
			defaultAxiosClient.put('/administration/timesheet/' + userId + '/' + yearMonth + '/planned/addabsence', createAbsenceDto)
				.then(response => processAbsenceSheet(commit, response))
				.then(() => processCanAdd(state, commit, rootState));
		},
		updateAbsence({commit, state}, updateAbsenceDto) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const userId = state.selectedTimeSheetInfo.userId;
			return defaultAxiosClient.put(`/administration/timesheet/${userId}/${yearMonth}/planned/updateabsence`, updateAbsenceDto)
				.then(response => processAbsenceSheet(commit, response));
		},
		removeAbsence({commit, state}, {yearMonth, removeAbsenceDto}) {
			const userId = state.currentlySelectedUserId;
			defaultAxiosClient.put(`/administration/timesheet/${userId}/` + yearMonth + '/planned/removeabsence', removeAbsenceDto)
				.then(response => processAbsenceSheet(commit, response));
		},
		updateWorkedShift({commit}, {contractId, yearMonth, workedShiftUpdateDto}) {
			workedShiftUpdateDto = shiftDtoEndDatePlusOneDayIfPastMidnight(workedShiftUpdateDto);
			return defaultAxiosClient.put('/administration/timesheet/' + contractId + '/' + yearMonth + '/worked/updateshift', workedShiftUpdateDto)
				.then(response => {
						commit('setAllWorkedShifts',
							{
								workedShifts: response.data.workedShiftDTOList,
								customerName: response.data.customerName,
								contractId: response.data.contractId
							});
					}
				);
		},
		updateWorkedShiftToAbsence({commit}, {contractId, yearMonth, transformWorkedShiftIntoAbsenceDto}) {
			return defaultAxiosClient.put('/administration/timesheet/' + contractId + '/' + yearMonth + '/worked/turnintoabsence', transformWorkedShiftIntoAbsenceDto)
				.then(response => {
					commit('setAllWorkedShifts',
						{
							workedShifts: response.data.workedCustomerShiftDto.workedShiftDTOList,
							customerName: response.data.workedCustomerShiftDto.customerName,
							contractId: response.data.workedCustomerShiftDto.contractId
						}
					);
					commit('timesheet/setAbsences', response.data.absenceDtos, {root: true});
				});
		},
		deleteWorkedShift({commit}, {contractId, yearMonth, workedShiftDeleteDto}) {
			return defaultAxiosClient.put('/administration/timesheet/' + contractId + '/' + yearMonth + '/worked/removeshift', workedShiftDeleteDto)
				.then(response =>
					commit('setAllWorkedShifts',
						{
							workedShifts: response.data.workedShiftDTOList,
							customerName: response.data.customerName,
							contractId: response.data.contractId
						}
					));
		},
		getAllActiveContractsAndPickSelected({state, commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			const contractId = state.currentlySelectedContractId;
			const userId = state.currentlySelectedUserId;
			return defaultAxiosClient.get(`/contract/${userId}/${yearMonth}/all`)
				.then(response => {
					const contractWithShiftTypesDtoList = response.data._embedded?.contractWithShiftTypesDtoList || [];
					const customer = contractWithShiftTypesDtoList.filter((c) => c.id === contractId)[0];
					commit('setAvailableShiftTypes', customer);
				})
				.catch(() => commit('resetState'));
		},
		getAllActiveContracts({commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);
			return defaultAxiosClient.get(`/contract/${yearMonth}/all`)
				.then(response => {
					const contractWithShiftTypesAndOrdersOutputDtoList = response.data._embedded?.contractWithShiftTypesAndOrdersOutputDtoList || [];
					commit('setActiveContracts', contractWithShiftTypesAndOrdersOutputDtoList);
				})
				.catch(() => commit('resetState'));
		},
		fetchWorkShifts({commit, state}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get('/timesheet/' + yearMonth + '/worked')
				.then(response => {
					commit('setAllWorkShifts', response.data.workedCustomerShiftDtos);
					commit('setCompleted', response.data.completed);
					commit('addToCompletedMappingObject', {
						contractId: state.currentlySelectedContractId,
						completed: response.data.completed
					});
				}).catch(() => commit('resetState'));
		},
		fetchAbsences({commit, state, rootState}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get('/timesheet/' + yearMonth + '/absences')
				.then(response => {
					processAbsenceSheet(commit, response);
				})
				.then(() => processCanAdd(state, commit, rootState))
				.catch(() => commit('resetState'));
		},
		fetchViewHourlyRateInfo({commit}) {
			const yearMonth = toYearAndMonth(this.state.time.currentlySelectedMonth);

			return defaultAxiosClient.get(`/administration/contract/${yearMonth}/hourlyratesinfo`)
				.then(response => commit('setViewHourlyRateInfo', response.data));
		},
		fetchAvailableVacationCountersForUser({commit, state}){
			const year = toYear(this.state.time.currentlySelectedMonth);
			const userId = state.currentlySelectedUserId;

			return defaultAxiosClient.get(`/administration/timesheet/${userId}/${year}/planned/availableVacationCounters`)
				.then(response => commit('setAvailableVacationCountersForUser', response.data))
				.catch(() => commit('resetState'));
		},
		fetchWorkedMonthlyHoursByYear({commit, state}){

			const year = toYear(state.time.currentlySelectedMonth);
			const userId = state.currentlySelectedUserId;

			return defaultAxiosClient.get(`/administration/recup/${year}/${userId}`)
				.then(response => {
					commit('setWorkedMonthlyHoursByYear', response.data);
				}		
				).catch(() => commit('resetState'));
		},
		addSpecificAbsence({commit, state, rootState}, {yearMonth, userId, specificAbsenceDto}) {
			defaultAxiosClient.put('/administration/timesheet/' + userId + '/' + yearMonth + '/planned/addSpecificAbsence', specificAbsenceDto)
				.then(response => processAbsenceSheet(commit, response))
				.then(() => processCanAdd(state, commit, rootState));
		},
	},
	isLocked() {
		return this.isLocked();
	},
};

function processAbsenceSheet(commit, response) {
	commit('timesheet/setAbsences', response.data.absenceDtos, {root: true});
	commit('timesheet/setHolidays', response.data.holidayDtos, {root: true});
}

function processAbsenceSheetAfterFullGet(commit, response) {
	commit('timesheet/setAbsences', response.data.customerTimesheetWorkedDto.absenceDtos, {root: true});
	commit('timesheet/setHolidays', response.data.customerTimesheetWorkedDto.holidayDtos, {root: true});
}

function processTimeSheet(commit, response, contractId) {
	commit('timesheet/setPlannedShifts', response.data.plannedShiftDtos, {root: true});
	commit('timesheet/setCompleted', response.data.completed, {root: true});
	commit('timesheet/addToCompletedMappingObject', {
		completed: response.data.completed,
		contractId: contractId
	}, {root: true});
	commit('timesheet/setOccupiedDays', response.data.occupiedDays, {root: true});
	commit('timesheet/setCountedHours', response.data.timeSheetHoursDto.worked, {root: true});
	commit('timesheet/setNeededHours', response.data.timeSheetHoursDto.needed, {root: true});
	commit('timesheet/setWorkedEnough', response.data.timeSheetHoursDto.workedEnough, {root: true});
	commit('timesheet/setRecupPreviousHours', response.data.timeSheetHoursDto.recupPrevious, {root: true});
	commit('timesheet/setRecupTakenHours', response.data.timeSheetHoursDto.recupTaken, {root: true});
	commit('timesheet/setRecupPreviousInDays', response.data.timeSheetHoursDto.recupPreviousInDays, {root: true});
	commit('timesheet/setRecupTakenInDays', response.data.timeSheetHoursDto.recupTakenInDays, {root: true});
	commit('timesheet/setLocked', response.data.locked, {root: true});
	commit('setPreviousMonthAvailable', response.data.previousMonthAvailable);
	commit('setNextMonthAvailable', response.data.nextMonthAvailable);
}

function processCanAdd(state, commit, rootState) {
	commit('timesheet/setCanAddRecupFullDay', state.recupTakenHours + rootState.user.currentLoggedUser.sickDayHours <= state.recupPreviousHours, {root: true});
	commit('timesheet/setCanAddRecupHalfDay', state.recupTakenHours + (rootState.user.currentLoggedUser.sickDayHours * 0.5) <= state.recupPreviousHours, {root: true});
	commit('timesheet/setCanAddVacationFullDay', state.remainingVacationDays >= 1, {root: true});
	commit('timesheet/setCanAddVacationHalfDay', state.remainingVacationDays >= 0.5, {root: true});
}

export default timesheet;
